import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { search, sortDate} from "../../util/sort";
import { renderImage } from "../../util/imageRenderer";
import { Button, DateFrom, DateTo } from "../../util/bloks";
// import { ManagerStorage } from "./ManagerStorage";
// import { DesignerStatus } from "../Designer/DesignerStatus";
import { ready } from "../../util/icon";
import { putFinishStatusFetch } from "../../features/action/fetchStatus";
import { checkIsName } from "../../features/redux/authSlice";
import { OrderHeader } from "../common/OrderHeader";
import { customStyles, designerOptions } from "../../util/option ";
import Select from "react-select/base";

const Status = () => {
  const { manager, loadStatus, countRip, countSewn } = useSelector(
    (state) => state.status
  );
  const [textSearch, setTextSearch] = useState("");
  const [filteredStatus, setFilteredStatus] = useState([]);
  const [confirmId, setConfirmId] = useState(null);
  const dispatch = useDispatch();

  const user = useSelector(checkIsName);
  const memoizedUser = useMemo(() => user, [user]);

  // Обработка завершения заказа
  const handleClickEnd = (id, order) => {
    setConfirmId({ id, order });
  };

  const handleConfirm = () => {
    dispatch(putFinishStatusFetch(confirmId.id, memoizedUser.username));
    setConfirmId(null);
  };

   // Выбор дизайнера
   const handleSelectChange = (e, id, designer) => {
    // if (e.value !== designer) {
    //   dispatch(putUpdateDesigner(id, e.value));
    // }
  };

  const handleToDate = () => {
    const sortedStatus = sortDate([...manager], "toDate"); // Клонируем массив перед сортировкой
    setFilteredStatus(sortedStatus);
  };
  const handleFromDate = () => {
    const sortedStatus = sortDate([...manager], "fromDate"); // Клонируем массив перед сортировкой
    setFilteredStatus(sortedStatus);
    
  };
  
  useEffect(() => {
    setFilteredStatus(search(manager, textSearch)); // Применяем фильтрацию по тексту
  }, [manager, textSearch]);
  

  return (
    <div>
      {confirmId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-2xl p-6 flex flex-col items-center gap-4 min-w-[260px]">
            <p className="font-rubik text-[#7D7D7D] text-base">Close order <span className="font-semibold text-[#739D00]">#{confirmId.order}</span>?</p>
            <div className="flex gap-3">
              <button onClick={handleConfirm} className="px-5 py-1.5 bg-[#e6e6e6] hover:bg-[#739D00] text-[#7D7D7D] hover:text-white font-rubik rounded-lg transition-colors">Confirm</button>
              <button onClick={() => setConfirmId(null)} className="px-5 py-1.5 bg-[#e6e6e6] hover:bg-[#739D00] text-[#7D7D7D] hover:text-white font-rubik rounded-lg transition-colors">Cancel</button>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col w-full">
        {/* Заголовки */}
        <OrderHeader
          onFromDateClick={handleFromDate}
          onToDateClick={handleToDate}
        />
        {/* Список заказов */}
        {loadStatus &&
          filteredStatus.map(
            (i, key) =>
              !i.end && (
                <div
                  className={`flex flex-row h-[70px] w-full mb-1 text-center rounded-[10px] bg-white border-solid border-2 border-[#dbdbdb]`}
                  key={key}
                >
                  {DateFrom(i.fromDate, i.toDate)}
                  {DateTo(i.toDate)}
                  {renderImage(i.manager)}
                  <div className="h-[40px] w-[2px] bg-[#dbdbdb] my-auto mt-[15px]"></div>
                  <div className=" w-[7%] flex items-center justify-center">
                      <Select
                        styles={customStyles}
                        options={designerOptions}
                        value={designerOptions.find(
                          (option) => option.value === i.designer
                        )}
                        onChange={(e) =>
                          handleSelectChange(e, i._id, i.designer)
                        }
                        onBlur={() => {}}
                        blurInputOnSelect={true}
                      />
                    </div>

                  {/* {i.place.trim() === "STUDIO" ? (
                    <DesignerStatus
                      status={i}
                      countRip={countRip}
                      countSewn={countSewn}
                    />
                  ) : (
                    <ManagerStorage status={i} />
                  )} */}
                 {Button(ready, () => handleClickEnd(i._id, i.order))}
                </div>
              )
          )}
      </div>
    </div>
  );
}


export default Status